import { useMemo } from 'react';
import { useFirestoreMultiple } from '../hooks/useFirestoreData';

import AboutAlldoer from '../components/Home/AboutAlldoer';
import CustomRequirement from '../components/Home/CustomRequirements';
import Hero from '../components/Home/Hero';
import SourcingCapabilities from '../components/Home/SourcingCapabilities';
import Testimonials from '../components/Home/Testimonials';
import Gallery from '../components/Home/Gallery';

function Home() {
    const collections = useMemo(
        () => ['testimonials', 'metrics', 'categories', 'app_config'],
        []
    );

    const { data, loading, error } = useFirestoreMultiple(collections);

    const testimonials = data.testimonials || [];
    const metrics = data.metrics || [];
    const categories = data.categories || [];
    const appConfig = data.app_config || [];

    if (error) {
        console.error('Error loading home page data:', error);
    }

    return (
        <div className="w-full flex flex-col items-center">
            <Hero metrics={metrics} loading={loading} />

            <div id="works" className="w-full">
                <AboutAlldoer metrics={metrics} loading={loading} />
            </div>

            <div id="catalogue" className="w-full">
                <SourcingCapabilities categories={categories} loading={loading} />
            </div>

            <div id="why-us" className="w-full">
                <Testimonials testimonials={testimonials} loading={loading} />
            </div>

            <div id="gallery" className="w-full">
                <Gallery />
            </div>

            <div id="contact" className="w-full">
                <CustomRequirement appConfig={appConfig} loading={loading} />
            </div>
        </div>
    );
}

export default Home;